<template>
  <div>
    <HeaderPurchase header="ดูรายละเอียด" :img_header="header_image" link_back="purchase"/>
    <Purchase_details/>
  </div>
</template>

<script>
import HeaderImage from '@/assets/compliance.png'
import HeaderPurchase from "@/components/admin/purchase/headerpurchase/HeaderPurchase.vue";
import Purchase_details from "@/components/admin/purchase/Purchase_details";

export default {
  name: "PurchaseDetails",
  components: {
    Purchase_details,
    HeaderPurchase
  },
  data() {
    return {
      header_image: HeaderImage
    }
  }
}
</script>

<style scoped>

</style>